import Vue from 'vue'
import AppSearchResult from './App.vue'

// Import and configure vue-moment
const moment = require('vue-moment')
Vue.use(moment)

// Le script est chargé sur toutes les pages WordPress : on ne monte l'app
// que si la div cible est réellement présente sur la page.
const mountEl = document.getElementById('ans-sub-header')

if (mountEl) {
  new Vue({
    render: (h) => h(AppSearchResult)
  }).$mount(mountEl)
}
